import { useLingui } from "@lingui/react";
import { formatNumber } from "@mobility-item-page/utilities";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const HoursUsed = ({ hoursUsed }: SpecProps<"hours_used">) => {
  const { i18n } = useLingui();
  const { locale } = useAppConfig();

  if (!hoursUsed) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.hoursUsed",
    message: "Hours used",
    comment: "Field for 'hours used' in ad specification",
  });
  return <FieldValuePair field={field} value={formatNumber(hoursUsed, locale)} />;
};
